import styled             from 'styled-components';

import { cssFlexColumn,
         cssFlexRow     } from 'src/providers/theme/shared';

type AttentionDialogLookAndFeel = {
  padding: number[]; 
  gap: number[];
  marginBottom: number; 
}

const attention_dialog: AttentionDialogLookAndFeel = {
  padding: [0, 16],
  gap: [16, 20, 67],
  marginBottom: 32
}

export type AttentionDialogVariants = 'attention_dialog_main'

export const attention_dialog_variants: Map<AttentionDialogVariants, AttentionDialogLookAndFeel> = new Map<AttentionDialogVariants, AttentionDialogLookAndFeel>([
  ['attention_dialog_main', attention_dialog],
]);

export const Container = styled.div<{
  lookAndFeel: AttentionDialogLookAndFeel
}>`
  ${cssFlexColumn};
  padding: ${(args) => args.lookAndFeel.padding[0]} ${(args) => args.lookAndFeel.padding[1]}px;
  gap: ${(args) => args.lookAndFeel.gap[2]}px;
`

export const InfoContainer = styled.div<{
  lookAndFeel: AttentionDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap[0]}px;
  padding: ${(args) => args.lookAndFeel.padding[1]}px;
`

export const ActionsContainer = styled.div<{
  lookAndFeel: AttentionDialogLookAndFeel
}>`
  ${cssFlexColumn};
  gap: ${(args) => args.lookAndFeel.gap[1]}px;
  margin-bottom: ${(args) => args.lookAndFeel.marginBottom}px;
`

export const CheckboxContainer = styled.div<{
  lookAndFeel: AttentionDialogLookAndFeel
}>`
  ${cssFlexRow};
  padding: ${(args) => args.lookAndFeel.padding[0]} ${(args) => args.lookAndFeel.padding[1]}px;
`